import Divider from "../Reuseable/Divider";

type Props = {};

const About = (props: Props) => {
  return (
    <div className="text-center">
      <div className="flex items-center flex-col">
        <p className="text-3xl font-bold border-b-2 w-fit p-2 text-center mt-4">
          DIBPos Application
        </p>
        <p className="py-1 font-semibold ">Registered / Licensed</p>
      </div>
      <div className=" mt-4 mb-6">
        <p>Client name: Jwellery POS</p>
        <p>Expiry date: 2024/03/06</p>
      </div>
      <Divider />
      <div className="my-2">
        <p>Copyright &#169; 2024 DibPOS</p>
        <p>Beta Version: 0.01</p>
      </div>
    </div>
  );
};
export default About;
